import { EverOn, Pluspot, SMtown, Tirepick } from "../../components/sections/projectSection/ProjectDetailContent";

export type ImageBox = [string, string?];
export type ContentAlign = 'left' | 'right';

export interface ProjectInvolve {
  pm?: string[];
  designer?: string[];
  fe?: string[];
  be?: string[];
}

// React.ReactNode
export interface ProjectInfo {
  color: string;
  client: string;
  consultings: string[];
  skills: string[];
  period: string;
  involve?: ProjectInvolve
  interviewLink?: string
}

export interface Project {
  key: string;
  title: string;
  subTitle: string;
  isMain?: boolean;
  cardBanner: string;
  detailBanner: {
    pc: string;
    tablet: string;
    mobile: string;
  };
  info: ProjectInfo
  content: React.ReactNode;
  nextBanner: string;
  isOpen: boolean;
  logoSrc?: string;
}

export const projects: Project[] = [
  {
    key: 'tire-pick',
    title: "타이어픽",
    subTitle: "카 커머스 플랫폼",
    isMain: true,
    cardBanner: '/image/webp/project/tirepick/tirepick-thumbnail.png',
    detailBanner: {
      pc: '/image/webp/project/tirepick/tirepick-banner-pc.webp',
      tablet: '/image/webp/project/tirepick/tirepick-banner-tablet.webp',
      mobile: '/image/webp/project/tirepick/tirepick-banner-mobile.webp'
    },
    info: {
      color: '#7B3FF1',
      client: '카티니',
      consultings: ['서비스 기획', 'UI / UX 디자인', 'iOS / AOS 개발', '웹서비스 통합개발',
        '서비스 개발 운영'],
      skills: ['Nest.js', 'ReactNative', 'React'],
      period: '2022. 04 - 2022. 12',
      involve: {
        pm: ['에릭'],
        fe: ['망고', '루이스', '로렘', '다니엘'],
        designer: ['이나', '해리', '유미'],
        be: ['볼리', '아르'],
      },
      interviewLink: 'https://brunch.co.kr/@team-slogup/179',
    },
    content: <Tirepick />,
    nextBanner: '/image/webp/project/smtown/smtown-next-banner.webp',
    isOpen: true,
    logoSrc: "/image/logo/tirepick-logo.svg"
  },
  {
    key: 'ever-on',
    title: "에버온",
    subTitle: "전기차 충전 플랫폼",
    isMain: true,
    cardBanner: '/image/webp/project/everon/everon-thumbnail.png',
    detailBanner: {
      pc: '/image/webp/project/everon/everon-banner-pc.webp',
      tablet: '/image/webp/project/everon/everon-banner-tablet.png',
      mobile: '/image/webp/project/everon/everon-banner-mobile.png'
    }, info: {
      color: '#01A8EF',
      client: '에버온',
      consultings: ['서비스 기획', 'UX/UI 디자인', 'iOS/AOS 개발'],
      skills: ['ReactNative'],
      period: '2022.04 ~ 2024.02',
      involve: {
        pm: ['스노우', '클로이'],
        fe: ['리버', '보노', '제시'],
        designer: ['해리', '채드'],
        be: ['만춘', '재이'],
      },
      interviewLink: 'https://brunch.co.kr/@team-slogup/182'
    },
    content: <EverOn />,
    nextBanner: '/image/webp/project/everon/everon-next-banner.webp',
    isOpen: true,
    logoSrc: "/image/logo/everon-logo.svg"
  },
  {
    key: 'sm-town',
    title: "SM TOWN",
    subTitle: "SM 팬 서비스 플랫폼",
    isMain: true,
    cardBanner: '/image/webp/project/smtown/smtown-thumbnail.png',
    detailBanner: {
      pc: '/image/webp/project/smtown/smtown-banner-pc.webp',
      tablet: '/image/webp/project/smtown/smtown-banner-tablet.webp',
      mobile: '/image/webp/project/smtown/smtown-banner-mobile.webp'
    }, info: {
      color: '#FF649A',
      client: 'SM 엔터테인먼트',
      consultings: ['서비스 기획', 'UX / UI 디자인', 'iOS / AOS 개발'],
      skills: ['React Native'],
      period: '2023. 06 - 진행중',
      involve: {
        pm: ['메이슨', '칸', '줄리아'],
        fe: ['제시', '미아'],
        designer: ['리아', '채드', '카야'],
        be: ['재이', '만춘'],
      }
    },
    content: <SMtown />,
    nextBanner: '/image/webp/project/smtown/smtown-next-banner.webp',
    isOpen: true,
    logoSrc: "/image/logo/sm-logo.svg"
  },
  {
    key: 'pluspot',
    title: "플러스팟",
    subTitle: "퍼스널 모빌리티 주차 솔루션 플랫폼",
    cardBanner: '/image/webp/project/pluspot/pluspot-thumbnail.png',
    detailBanner: {
      pc: '/image/webp/project/pluspot/pluspot-banner-pc.webp',
      tablet: '/image/webp/project/pluspot/pluspot-banner-tablet.webp',
      mobile: '/image/webp/project/pluspot/pluspot-banner-mobile.webp'
    }, info: {
      color: '#905DF6',
      client: 'LG 전자 커런트닷',
      consultings: ['서비스 기획', 'UI / UX 디자인', 'iOS / AOS 개발', '웹서비스 통합개발',
        '서비스 개발 운영'],
      skills: ['Nest.js', 'ReactNative', 'React'],
      period: '2022. 04 - 진행중',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['애니', '웨이드', '소닉', '망고', '루이스', '제트'],
        designer: ['스토미'],
        be: ['에디', '에반', '피오', '우드로'],
      },
    },
    content: <Pluspot />,
    nextBanner: '/image/webp/project/pluspot/pluspot-next-banner.webp',
    isOpen: true,
    logoSrc: "/image/logo/pluspot-logo.svg"
  },
  {
    key: 'ls-mtron',
    title: "LS 엠트론",
    subTitle: "트랙터 관제 및 원격 시동 플랫폼 ",
    cardBanner: '/image/webp/project/lsmtron/lsmtron-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '/image/webp/project/lsmtron/lsmtron-next-banner.webp',
    isOpen: false,
  },
  {
    key: 'medi-order',
    title: "메디오더",
    subTitle: "병원 / 클리닉 의료기기 발주 플랫폼",
    isMain: true,
    cardBanner: '/image/webp/project/mediorder/mediorder-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '',
    isOpen: false,
  },
  {
    key: 'ecoya-earth',
    title: "에코야 얼스",
    subTitle: "생활 속 친환경 실천 장려 플랫폼",
    cardBanner: '/image/webp/project/ecoyaearth/ecoyaearth-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '',
    isOpen: false,
  },
  {
    key: 'mintit',
    title: "민팃",
    subTitle: "AI 기반 중고폰 거래 플랫폼",
    cardBanner: '/image/webp/project/mintit/mintit-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '',
    isOpen: false,
  },
  {
    key: 'sk-direct',
    title: "SK렌터카 다이렉트",
    subTitle: "다이렉트 자동차 렌탈 서비스 플랫폼",
    cardBanner: '/image/webp/project/skdirect/skdirect-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '',
    isOpen: false,
  },
  {
    key: 'carpet',
    title: "CARPET",
    subTitle: "수입자 케어 토탈 솔루션",
    cardBanner: '/image/webp/project/carpet/carpet-thumbnail.png',
    detailBanner: {
      pc: '',
      tablet: '',
      mobile: ''
    }, info: {
      color: '',
      client: '',
      consultings: [],
      skills: [],
      period: '',
      involve: {
        pm: ['메이슨', '줄리아'],
        fe: ['리버', '보노'],
        designer: ['해리', '채드'],
        be: ['재이'],
      }
    },
    content: <></>,
    nextBanner: '',
    isOpen: false,
  },
];


export const mainProjects = projects.filter(project => project.isMain);